import { storeProjectWriteIntent } from './project-write-outbox';
import { createWriteStamp } from './write-clock';
import type { ProjectWriteOperation } from './write-operation';

export type ProjectWriteOperationInput = Pick<
    ProjectWriteOperation,
    'scope' | 'feature' | 'capability' | 'conflictUnit' | 'kind' | 'payload'
> & {
    actorId: string;
};

export function createProjectWriteOperation(input: ProjectWriteOperationInput): ProjectWriteOperation {
    const stamp = createWriteStamp(input.actorId);
    return {
        id: stamp.clientWriteId,
        scope: input.scope,
        actorId: input.actorId,
        deviceId: stamp.deviceId,
        stamp,
        feature: input.feature,
        capability: input.capability,
        conflictUnit: input.conflictUnit,
        kind: input.kind,
        payload: input.payload,
        createdAtMs: stamp.wallTimeMs,
    };
}

export async function createAndStoreProjectWriteIntent(input: ProjectWriteOperationInput): Promise<ProjectWriteOperation> {
    const operation = createProjectWriteOperation(input);
    await storeProjectWriteIntent(operation);
    return operation;
}

/** @deprecated Use createAndStoreProjectWriteIntent for create-and-store write intent flows. */
export const enqueueProjectWriteOperation = createAndStoreProjectWriteIntent;
